import { LoginOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import styles from "../../services/styles";
import SL_Button from "../buttons/Button";
import logo from '../../assets/logo.png'
import menus, { sideMenuItensIconsStyle, topMenuItensIconsStyle } from "../../components/menu/Menus"
import { Link, useLocation } from "react-router-dom";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { displayMessage } from "../../helpers/messages";

const { COLORS } = styles

export default function SideMenu() {
    const location = useLocation()

    const {
        setLoggedUser,
        isAdmin,
        windowWidth, windowHeight,
        mobile_mode
    } = useContext(GeneralContext)

    const [collapsed, setCollapsed] = useState(true);
    const [menu_selected_keys, setMenuSelectedKeys] = useState([])

    const menuOptions = [
        ...menus.userSideMenuItens,
        ...(isAdmin ? menus.adminSideMenuItens : []),
        ...menus.topMenuItens
    ]

    useEffect(() => {
        selectMenuOnLoading()
    }, [location])

    const selectMenuOnLoading = () => {
        let pathOption = window.location.pathname
        if (pathOption == '/') {
            setMenuSelectedKeys([menus.userSideMenuItens[0].key])
            return
        }

        const index = pathOption.indexOf('/', 1)

        if (index > 0) {
            pathOption = pathOption.substring(0, index)
        }

        const foundCurrentOption = menuOptions.find(e => e.key == pathOption)

        if (foundCurrentOption) {
            setMenuSelectedKeys([foundCurrentOption.key])
        }
    }

    const handleOnClickLogout = () => {
        setLoggedUser(null)
    }

    // Lida com clique nos menus
    const handleOnClickItemMenu = e => {
        setMenuSelectedKeys([e.key])
    }

    // Abre e fecha sidebars
    const toggle = () => setCollapsed(!collapsed)

    const listSideMenuItens = [
        ...menuOptions.map(
            item => {
                return {
                    key: item.key,
                    icon: (
                            <div style={{ color: menu_selected_keys && menu_selected_keys[0] == item.key ? COLORS.GREEN[900] : 'white' }}>
                            {item.icon}
                        </div>
                    ),
                    label: (
                        <Link
                            style={{
                                color: menu_selected_keys && menu_selected_keys[0] == item.key ? 'white' : 'white',
                                fontSize: 16,
                                fontWeight: 500,
                            }}
                            to={item.key}
                        >
                            <span>{item.title}</span>
                        </Link>
                    )
                }
            }
        ),

        {
            key: '/login',
            icon: <LoginOutlined style={{ ...sideMenuItensIconsStyle, color: `white` }} />,
            label: (
                <Link
                    style={{
                        color: 'white',
                        fontSize: 16,
                    }}
                    to={'/login'}
                    onClick={handleOnClickLogout}
                >
                    <span>{displayMessage('LOGOUT')}</span>
                </Link>
            )
        }
    ]

    return (
        <Sider trigger={null} collapsible collapsed={collapsed} width={300}>
            <div style={{ display: 'flex', flexDirection: 'column', background: 'white', height: '100%' }}>
                <div
                    style={{
                        height: collapsed ? 64 : 140,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        borderRight: `2px solid ${COLORS.GREEN[900]}`,
                        marginBottom: 0,
                        transition: 'all 1s',
                    }}
                >
                    {
                        !collapsed &&
                        <img
                            // width={!collapsed ? 140 : '0px'}
                            height={'100%'}
                            width={"100%"}
                            style={{ padding: collapsed ? 0 : 10, aspectRatio: 1 }}
                            src={logo}
                        />
                    }

                    <div style={{ width: collapsed ? '100%' : '30%', borderBottom: collapsed && `2px solid ${COLORS.GREEN[900]}`, display: 'flex', justifyContent: 'center', alignItems: 'center', transition: 'all 1s', }}>
                        <SL_Button type="primary" onClick={toggle} style={{ background: COLORS.GREEN[900], borderColor: COLORS.GREEN[900], justifyContent: "center", borderRadius: 20, width: 54, height: 41 }}>
                            {
                                React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                    className: 'trigger',
                                    onClick: toggle,
                                    style: { justifyContent: "center", fontSize: 24 }
                                })
                            }
                        </SL_Button>
                    </div>
                </div>

                <Menu
                    mode="inline"
                    defaultOpenKeys={['menu']}
                    style={{ flex: 1, borderRight: 0, background: COLORS.GREEN[900], paddingTop: 20 }}
                    selectedKeys={menu_selected_keys}
                    inlineCollapsed={collapsed}
                    onSelect={handleOnClickItemMenu}
                    items={listSideMenuItens}
                />
            </div>
        </Sider>
    )
} 